import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import crud from "./slices/crudSlice";
// import createData from "./slices/createDataSlice";

const rootReducer = (asyncReducers) => (state, action) => {
	const combinedReducer = combineReducers({
		theme,
		auth,
		crud,
		// createData,
		...asyncReducers,
	});
	return combinedReducer(state, action);
};

export default rootReducer;
